import { Component, OnInit } from '@angular/core';
import { AdminService } from '../../../services/admin/admin.service';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-merchant-manager',
  templateUrl: './merchant-manager.component.html',
  styleUrls: ['./merchant-manager.component.scss']
})
export class MerchantManagerComponent implements OnInit {

  merchants: any[] = [];

  loading = true;
  error = '';
  successMsg = '';

  reviewMerchant: any = null;
  saving = false;

  constructor(private adminService: AdminService) {}

  ngOnInit(): void {
    this.loadMerchants();
  }


  loadMerchants(): void {

    this.loading = true;
    this.error = '';

    this.adminService.getPendingMerchants().subscribe({

      next: (res) => {

        if (res.status === 'success') {
          this.merchants = res.data || [];
        } else {
          this.error = res.message || 'Unable to load merchants';
        }

        this.loading = false;
      },

      error: (err) => {
        this.error = err.error?.message || 'Server error';
        this.loading = false;
      }

    });
  }


  getImageUrl(url: string): string {

  if (!url) return '';

  if (url.startsWith('http')) {
    return url;
  }

  if (url.startsWith('/')) {
    return `${environment.apiUrl}${url}`;
  }

  return `${environment.apiUrl}/auth/image/${url}`;
}



  openReview(merchant: any): void {

    this.reviewMerchant = {
      ...merchant
    };

  }


  closeReview(): void {
    this.reviewMerchant = null;
  }



  updateStatus(status: string): void {

    if (!this.reviewMerchant) return;


    const message =
      status === 'approved'
      ? 'Approve this merchant?'
      : 'Reject this merchant?';


    if (!confirm(message)) return;


    this.saving = true;


    this.adminService
      .updateMerchantStatus(
        this.reviewMerchant._id,
        status
      )
      .subscribe({

        next:(res)=>{

          this.saving = false;


          if(res.status === 'success'){

            this.successMsg =
            `Merchant ${status}`;


            this.closeReview();

            this.loadMerchants();

            setTimeout(()=>{
              this.successMsg='';
            },4000);

          }

        },


        error:(err)=>{

          this.saving=false;

          alert(
            err.error?.message ||
            'Status update failed'
          );

        }

      });


  }


}